import Carousel from 'react-bootstrap/Carousel';
import { FaArrowRight } from 'react-icons/fa';
import Eveteasing from "../../images/EveTeasing.jpg"
import Menstrual from "../../images/Menstrual Health.jpg"
import Domestic from "../../images/Domestic Violence.jpg"
import Gender from "../../images/Gender Inequality.jpg"
import Digital from "../../images/Digital Gender Divide.jpg"
import Poor from "../../images/Poor Nutrition.jpg"
import Genderpay from "../../images/Gender Pay Gap.jpg"
import Dowry from '../../images/Dowry.jpg'

import '../Focus/Focus.css'
import { pink, green, white } from './../../constants'
function FocusSlider() {


  const list = [
    {
      title: "Eve Teasing",
      des: "A Growing Concern for Women's Safety",
      src: Eveteasing,
    },
    {
      title: "Menstrual Health",
      des: "A Critical Issue for Women in India",
      src: Menstrual,
    },
    {
      title: "Domestic Violence",
      des: "A Widespread Concern for Women in India",
     src: Domestic,
    },


    {
      title: "Gender Inequality",
      des: "A Continuing Challenge for Women's Empowerment",
      src: Gender,
    },


    {
      title: "Digital Gender Divide",
      des: "Bridging the Gap for Gender Equality",
      src: Digital,
    },

    {
      title: "Poor Nutrition",
      des: "A Silent Threat to Women's Health in India",
      src: Poor,
    },

    {
      title: "Gender Pay Gap",
      des: "A Growing Concern for the Societal Progress",
      src: Genderpay,
    },


    {
      title: "Dowry Issues",
      des: "An Ongoing Social Evil in Various Communities across India.",
      src: Dowry,
    }



  ]

  const handleclick = () => {
    const link = "https://drive.google.com/file/d/1gfcq4ECX3G3BbCQzTaRtI2zIIEvc4Opq/view?usp=sharing";
    window.open(link, '_blank', 'noreferrer');
}









  return (

    

    <div className="my__carousel_main">

      <Carousel variant="light" >

        {list.map((val, index) => {
          return <Carousel.Item key={index} interval={3000} style={{ position: "relative" }}>

            <div className='focus-item-container'>


              <div className='dull' >
                <span style={{ fontWeight: "600", fontSize: "30px", color: "white", textAlign: "start", }}>{val.title}</span>
                <span style={{ fontSize: "13px", color: "white", textAlign: "start" }}>{val.des}</span>
                <button className='button-style' onClick={handleclick} >Read more <FaArrowRight></FaArrowRight></button>
              </div>

              <img
                className="d-block w-100"
                src={val.src}
                alt="First slide"
              />

            </div>

          </Carousel.Item>
        })}





      </Carousel>

    </div>
  );
}

export default FocusSlider;